// Rewrite a Cloudinary delivery URL into an optimized, right-sized variant.
//   f_auto    — modern formats (WebP/AVIF) when the browser supports them
//   q_auto:good — perceptual auto quality, biased a notch higher to preserve detail
//   dpr_auto  — crisp on Retina / high-DPR screens
//   w_<width>,c_limit — cap to the displayed width, never upscale
//
// Safe no-op for non-Cloudinary URLs, for non-image (video) URLs, and for URLs
// that already carry an f_auto/q_auto transform (idempotent). Mirrors the
// existing server-side cloudinaryForVision() URL-rewrite pattern.
export function cloudinaryForDisplay(url, width) {
  if (!url || !url.includes('res.cloudinary.com')) return url;
  if (!url.includes('/image/upload/')) return url;            // leave video/raw URLs alone
  if (/\/image\/upload\/[^/]*(f_auto|q_auto)/.test(url)) return url; // already optimized
  const parts = ['f_auto', 'q_auto:good', 'dpr_auto'];
  if (width) parts.push(`w_${width}`, 'c_limit');
  return url.replace('/image/upload/', `/image/upload/${parts.join(',')}/`);
}

// Optimize a Cloudinary VIDEO delivery URL — q_auto picks the best quality/size
// for each viewer. Note: the first request transcodes (a brief one-time delay,
// then cached); the instant low-res preview bridges that gap. Safe no-op for
// non-Cloudinary / non-video URLs and for URLs already optimized (idempotent).
export function cloudinaryForVideo(url) {
  if (!url || !url.includes('res.cloudinary.com')) return url;
  if (!url.includes('/video/upload/')) return url;
  if (/\/video\/upload\/[^/]*q_auto/.test(url)) return url; // already optimized
  return url.replace('/video/upload/', '/video/upload/q_auto/');
}
